/* Site-wide sale layer (config and dates: snippets/jb-campaign.liquid). Vanilla, deferred, no-op outside a campaign.
   - Announcement bar: replaced by the campaign line, plain text with no link (owner 2026-10-19 19:13).
     Returning customers see the campaign's barRet line with their own % between retStart and retEnd (Amit 2026-10-20
     13:31). Returning = a remembered BLACK30 / BLACK35 email/SMS code, or a logged-in customer with past orders
     (window.JB_RET, snippets/jb-campaign.liquid); their code is applied like any site code. v139 (Amit 2026-10-28):
     returning BLACK30 (bar "Your customer offer"), only a remembered BLACK35 (VIP list, camp.vip) gets 35% (bar
     camp.barVip "Your VIP offer"); no step up in the last chance and no 40% (CYBER40 retired).
     Black November last chance ("lastSite", Nov 30 - Dec 1): new visitors get CYBER25.
     Seasons without a returning code (Christmas, New Year: one offer for everyone, owner 2026-10-20) never show it.
   - Product pages: a line with the extra % above the arrival box ([data-jb-arrival], under Add to cart).
   - Cart: the visitor's code is added automatically whenever the cart has products and the code is missing,
     through window.JBCart (serialized with every other cart write); other codes in the cart are kept.
   - Email links ?c=CODE are remembered (localStorage) and win over the site code when they are valid now.
   - A higher sale code already in the cart (e.g. a /discount/BLACK35 or /discount/CHRISTMAS30 link) that is valid now
     is kept, not replaced, and remembered like ?c=. Valid now: the season's site code; its returning code from
     retStart (BLACK30 and the VIP code BLACK35 from Nov 24 to Dec 1); its last-chance codes only between lastStart
     and lastEnd (CYBER25 Nov 30 - Dec 1, CHRISTMAS30 Dec 13-17, NEWYEAR30 Jan 8-12). A code of ours that is not valid on the site any more
     but is still higher than the site code and still inside its Shopify dates (C.keepUntil) is left in the cart too:
     the layer never swaps a better code for a worse one. window.JBCampaignState.validNow / remember are used by
     assets/jb-bf.js too.
   - On a sale landing page (assets/jb-bf.js) the page's code wins. Skips the bun wardrobe page (#jbx). */
(() => {
  const C = window.JBCAMP;
  if (!C || window.JBCampaignState) return;
  const now = () => C.now0 + (Date.now() - C.t0);
  const KEY = 'jb_camp_code';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* is this code one the visitor may get right now (by the campaign dates)? */
  const validNow = (c) => {
    c = String(c || '').toUpperCase();
    const t = now();
    return C.campaigns.some((x) => t >= Date.parse(x.start) && t < Date.parse(x.end) && (
      c === x.new ||
      (((!!x.ret && c === x.ret) || (!!x.vip && c === x.vip)) && t >= Date.parse(x.retStart || x.start) && t < Date.parse(x.retEnd || x.end)) ||
      (!!x.last && ((!!x.last.new && c === x.last.new) || (!!x.last.ret && c === x.last.ret)) && t >= Date.parse(x.lastStart) && t < Date.parse(x.lastEnd))));
  };
  /* still inside its Shopify dates (snippets/jb-campaign.liquid "keepUntil"): only used to never drop a better code */
  const stillOk = (c) => {
    c = String(c || '').toUpperCase();
    const u = C.keepUntil && C.keepUntil[c];
    return !!u && now() < Date.parse(u);
  };
  const remember = (c) => {
    c = String(c || '').toUpperCase();
    if (!C.codes[c]) return;
    try { localStorage.setItem(KEY, JSON.stringify({ code: c, t: Date.now() })); } catch (e) {}
  };

  /* remember an email code */
  const m = location.search.match(/[?&]c=([A-Za-z0-9]+)/);
  if (m && C.codes[m[1].toUpperCase()]) remember(m[1]);
  let remembered = null;
  try { const r = JSON.parse(localStorage.getItem(KEY) || 'null'); if (r && C.codes[r.code] && Date.now() - r.t < 90 * 864e5) remembered = r.code; } catch (e) {}

  const camp = C.active;
  if (!camp) { window.JBCampaignState = { active: false, remembered, validNow, stillOk, remember }; return; }
  /* returning: a remembered returning code, or logged in with past orders (window.JB_RET, set in Liquid) */
  let returning = !!camp.ret && ((!!remembered && C.returning.indexOf(remembered) > -1) || window.JB_RET === true);
  const t = now();
  const inRet = !!camp.ret && t >= Date.parse(camp.retStart || camp.start) && t < Date.parse(camp.retEnd || camp.end);
  const inLast = !!camp.lastSite && !!camp.last && t >= Date.parse(camp.lastStart) && t < Date.parse(camp.lastEnd);
  /* the code this visitor gets right now: returning BLACK30 the whole time (also in the last chance, no step up;
     a remembered BLACK35 wins below because it is higher), else last chance CYBER25, else BLACK20 */
  const ladder = () => {
    if (returning && inRet) return (inLast && camp.last && camp.last.ret) || camp.ret;
    if (inLast) return camp.last.new || camp.new;
    return camp.new;
  };
  let code = ladder();
  if (remembered && validNow(remembered) && C.codes[remembered] > C.codes[code]) code = remembered;
  let pct = C.codes[code];
  let vip = returning && inRet;
  window.JBCampaignState = { active: true, id: camp.id, label: camp.label, code, pct, returning, vip, remembered, validNow, stillOk, remember };
  const fill = (s) => String(s || '').replace(/\[pct\]/g, pct).replace(/\[code\]/g, code);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const wardrobe = () => !!document.getElementById('jbx');

  const paint = (again) => {
    /* announcement bar */
    document.querySelectorAll('.jb-announce').forEach((bar) => {
      if (bar.hasAttribute('data-jb-camp') && !(again && bar.getAttribute('data-jb-camp') === camp.id)) return;
      bar.setAttribute('data-jb-camp', camp.id);
      bar.classList.remove('jb-announce--multi');
      bar.removeAttribute('data-jb-announce');
      bar.removeAttribute('role'); bar.removeAttribute('aria-roledescription'); bar.removeAttribute('aria-label');
      const text = vip
        ? fill((camp.vip && code === camp.vip && camp.barVip) || camp.barRet || 'Your customer offer: extra [pct]% off, ' + camp.label)
        : fill(camp.bar);
      /* plain text, no link and no underline (owner 2026-10-19 19:13) */
      bar.innerHTML = '<p>' + esc(text) + '</p>';
    });
    document.documentElement.classList.add('jb-camp-ready');
    /* line under Add to cart on product pages */
    document.querySelectorAll('[data-jb-arrival]').forEach((arr) => {
      const prev = arr.previousElementSibling;
      if (prev && prev.classList.contains('jb-camp-atc')) {
        if (again) { const s = prev.querySelector('span'); if (s) s.textContent = fill(camp.atc); }
        return;
      }
      const p = document.createElement('p');
      p.className = 'jb-camp-atc';
      p.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12l-8 8-9-9V3h8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg><span>' + esc(fill(camp.atc)) + '</span>';
      arr.parentNode.insertBefore(p, arr);
    });
  };

  /* keep the code on the cart */
  let busy = false;
  let lastTry = '';
  const sync = async () => {
    if (busy || wardrobe() || !window.JBCart || !window.JBCart.safePost) return;
    busy = true;
    try {
      const cart = await fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const list = (cart.discount_codes || []).map((d) => String(d.code));
      /* on a sale landing page the page's own code wins (it knows the audience), except before that page opens */
      const bf = window.JBBF && window.JBBF.code && !document.documentElement.classList.contains('jb-bf-early-mode');
      const want = bf ? window.JBBF.code : code;
      if (!cart.item_count || list.some((c) => c.toUpperCase() === want)) return;
      /* a higher sale code of ours already in the cart that is valid now (e.g. a /discount/BLACK35 link): keep it,
         remember it like ?c= and show its % (never replace a better code with the site code) */
      const held = list.map((c) => c.toUpperCase())
        .filter((c) => C.codes[c] && C.codes[c] > (C.codes[want] || 0) && validNow(c))
        .sort((a, b) => C.codes[b] - C.codes[a])[0];
      if (held) {
        remember(held);
        if (held !== code) {
          code = held; pct = C.codes[held];
          if (camp.ret && C.returning.indexOf(held) > -1) returning = true;
          vip = returning && inRet;
          /* a returning code makes her returning: her own ladder step may be higher still (never lower) */
          const up = ladder();
          const raise = !bf && C.codes[up] > C.codes[held];
          if (raise) code = up;
          pct = C.codes[code];
          Object.assign(window.JBCampaignState, { code, pct, returning, vip, remembered: held });
          paint(true);
          /* home banner follows (sections/jb-hero.liquid) */
          if (C.heroFor && window.JBHeroSync) { C.vip = vip; C.heroCode = code; C.heroId = C.heroFor(vip, code); window.JBHeroSync(); }
          if (raise) { busy = false; return await sync(); }
        }
        return;
      }
      /* a code of ours that is no longer offered on the site but still works at checkout and is better than the
         site code (e.g. CHRISTMAS30 in the cart on Dec 19): leave it, never swap a better code for a worse one */
      const kept = list.map((c) => c.toUpperCase())
        .some((c) => C.codes[c] && C.codes[c] > (C.codes[want] || 0) && stillOk(c));
      if (kept) return;
      const key = cart.token + '|' + want + '|' + cart.item_count;
      if (key === lastTry) return; /* tried for this exact cart already: don't loop */
      lastTry = key;
      /* drop older campaign codes from this layer, keep every other code */
      const ours = Object.keys(C.codes);
      const keep = list.filter((c) => ours.indexOf(c.toUpperCase()) === -1);
      const store = window.JBCart.store;
      const ids = store && store.sectionIds ? store.sectionIds() : [];
      const body = { discount: keep.concat(want).join(',') };
      if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
      const r = await window.JBCart.safePost('cart/update.js', body);
      const json = r && r.json;
      if (store && json && json.sections) { store.render(json.sections); store.afterRender(json); }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: json, baseEvent: 'jb:campaign' } }));
    } catch (e) {
      /* never surface errors to the shopper */
    } finally { busy = false; }
  };
  const later = () => setTimeout(sync, 400);
  ['cart:change', 'cart:updated', 'variant:add', 'jb:bundle-added'].forEach((ev) => document.addEventListener(ev, (e) => {
    if (e && e.detail && e.detail.baseEvent === 'jb:campaign') return;
    later();
  }));

  const init = () => { paint(); (window.requestIdleCallback || ((fn) => setTimeout(fn, 1500)))(sync); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();